/**
 * External dependencies
 */
import { disabledBlocks, i18n  } from 'cartzillagb'
import { range } from '~cartzillagb/util'
import { TeamMemberIcon } from '~cartzillagb/icons'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

const schema = {
	className: {
		type: 'string',
	},
	limit: {
		type: 'limit',
		default: 6,
	},
	lgColumns: {
		type: 'number',
		default: 3,
	},
	mdColumns: {
		type: 'number',
		default: 2,
	},
	smColumns: {
		type: 'number',
		default: 2,
	},
}

const maxLimit = applyFilters( 'cartzillagb.team-member.edit.inspector.max.limit', 12 )


{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `mediaURL${ i }` ] = {
		type: 'string',
	}
	schema[ `name${ i }` ] = {
		type: 'string',
		
	}
	schema[ `position${ i }` ] = {
		type: 'string',
	}
	schema[ `mailicon${ i }` ] = {
		type: 'string',
	}
	schema[ `linktext${ i }` ] = {
		type: 'string',
	}
} ) }

export const name = 'czgb/team-member'

export const settings = {
	title: __( 'Team Member', i18n ),
	icon: TeamMemberIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'team-member', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	description: __( 'Display members of your team or your office. Use multiple Team Member blocks if you have a large team.', i18n ),
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}
